export default __webpack_public_path__ + "static/media/Path 20089.2f1bae62.jpg";